export const termsContent = `# TERMINOS Y CONDICIONES DE USO

## PricingIntelligence

---

> **AVISO IMPORTANTE:** Este documento es un modelo referencial y requiere revision obligatoria por un abogado habilitado en el Estado Plurinacional de Bolivia antes de su publicación o uso. No constituye asesoramiento juridico. Los placeholders indicados entre corchetes [ASI] deben ser completados con la información correspondiente antes de su entrada en vigencia.

---

**Razon Social del Proveedor:** [NOMBRE DE LA EMPRESA]
**NIT:** [NIT]
**Domicilio Legal:** [DIRECCION], [CIUDAD], Estado Plurinacional de Bolivia
**Correo Electronico de Contacto:** [EMAIL_CONTACTO]
**Sitio Web:** [URL_SITIO_WEB]

**Fecha de entrada en vigencia:** [FECHA_VIGENCIA]
**Ultima actualizacion:** [FECHA_ACTUALIZACION]

---

## INDICE

1. [Definiciones](#1-definiciones)
2. [Aceptacion de los Terminos](#2-aceptacion-de-los-terminos)
3. [Descripcion del Servicio](#3-descripcion-del-servicio)
4. [Registro y Cuentas de Usuario](#4-registro-y-cuentas-de-usuario)
5. [Planes y Suscripciones](#5-planes-y-suscripciones)
6. [Obligaciones del Usuario](#6-obligaciones-del-usuario)
7. [Uso Aceptable](#7-uso-aceptable)
8. [Asistente de Inteligencia Artificial](#8-asistente-de-inteligencia-artificial)
9. [Monitoreo de Precios de Competidores (Scraping)](#9-monitoreo-de-precios-de-competidores-scraping)
10. [Propiedad Intelectual](#10-propiedad-intelectual)
11. [Propiedad de los Datos del Cliente](#11-propiedad-de-los-datos-del-cliente)
12. [Privacidad y Proteccion de Datos](#12-privacidad-y-proteccion-de-datos)
13. [Limitacion de Responsabilidad](#13-limitacion-de-responsabilidad)
14. [Indemnizacion](#14-indemnizacion)
15. [Disponibilidad del Servicio y Fuerza Mayor](#15-disponibilidad-del-servicio-y-fuerza-mayor)
16. [Modificaciones a los Terminos](#16-modificaciones-a-los-terminos)
17. [Suspension del Servicio](#17-suspension-del-servicio)
18. [Terminacion](#18-terminacion)
19. [Efectos de la Terminacion](#19-efectos-de-la-terminacion)
20. [Resolucion de Disputas](#20-resolucion-de-disputas)
21. [Ley Aplicable y Jurisdiccion](#21-ley-aplicable-y-jurisdiccion)
22. [Cesion](#22-cesion)
23. [Divisibilidad](#23-divisibilidad)
24. [Comunicaciones y Notificaciones](#24-comunicaciones-y-notificaciones)
25. [Acuerdo Completo](#25-acuerdo-completo)
26. [Disposiciones Finales](#26-disposiciones-finales)

---

## 1. DEFINICIONES

A los efectos de los presentes Terminos y Condiciones de Uso (en adelante, los "Terminos"), los siguientes conceptos tendran el significado que se indica a continuacion:

**1.1. "Plataforma" o "PricingIntelligence" o "PI":** El sistema de software como servicio (SaaS) accesible a traves de [URL_SITIO_WEB], que comprende todas las funcionalidades, modulos, interfaces, aplicaciones y servicios conexos proporcionados por el Proveedor.

**1.2. "Proveedor":** [NOMBRE DE LA EMPRESA], sociedad constituida conforme a las leyes del Estado Plurinacional de Bolivia, identificada con NIT [NIT], con domicilio en [DIRECCION], [CIUDAD].

**1.3. "Usuario":** Toda persona natural o juridica que accede a la Plataforma, ya sea en calidad de visitante, usuario registrado, administrador de Tenant o usuario final.

**1.4. "Tenant":** La organizacion, empresa o entidad comercial que contrata el Servicio y bajo cuyo ambito se crean las cuentas de usuario. Cada Tenant opera en un entorno logicamente aislado dentro de la Plataforma.

**1.5. "Administrador del Tenant":** El Usuario designado por el Tenant con facultades para gestionar cuentas, configuraciones, modelos de precios y demas aspectos administrativos del Tenant dentro de la Plataforma.

**1.6. "Servicio":** El conjunto de funcionalidades ofrecidas por la Plataforma, incluyendo pero no limitado a: gestion de modelos de precios, generacion y administracion de cotizaciones, flujos de aprobacion, gestion de materiales, asistente de inteligencia artificial, monitoreo de precios de competidores, generacion de reportes y documentos, y toda funcionalidad adicional que el Proveedor incorpore.

**1.7. "Datos del Cliente":** Toda informacion, datos, documentos, materiales, configuraciones, modelos de precios, cotizaciones y demas contenido que el Usuario o el Tenant ingresen, carguen, generen o almacenen en la Plataforma.

**1.8. "Asistente de IA":** La funcionalidad de inteligencia artificial integrada en la Plataforma, que utiliza modelos de lenguaje proporcionados por terceros (Anthropic, Inc.) para generar respuestas, sugerencias y analisis basados en los datos disponibles.

**1.9. "Credenciales de Acceso":** El correo electronico, contrasena y cualquier otro mecanismo de autenticacion utilizado para acceder a la Plataforma.

**1.10. "Plan":** El nivel de suscripcion contratado por el Tenant, que determina las funcionalidades disponibles, limites de uso y precio del Servicio.

**1.11. "Monitoreo de Precios" o "Scraping":** La funcionalidad de la Plataforma que permite recopilar informacion de precios publicada en fuentes de acceso publico en internet para fines de analisis competitivo.

**1.12. "Contenido Generado por IA":** Cualquier texto, analisis, recomendacion, sugerencia o dato producido por el Asistente de IA en respuesta a consultas del Usuario.

---

## 2. ACEPTACION DE LOS TERMINOS

**2.1.** El acceso y uso de la Plataforma implican la aceptacion plena e incondicional de los presentes Terminos por parte del Usuario, de conformidad con lo establecido en el articulo 454 del Codigo Civil boliviano (Decreto Ley 12760) sobre la libertad contractual.

**2.2.** Al registrarse en la Plataforma, el Usuario declara y garantiza que:

   a) Es mayor de dieciocho (18) anos de edad y tiene plena capacidad legal para contratar conforme al derecho boliviano;

   b) Si actua en representacion de una persona juridica, cuenta con las facultades y autorizaciones suficientes para obligar a dicha entidad al cumplimiento de estos Terminos;

   c) Ha leido, comprendido y acepta integramente los presentes Terminos, la Politica de Privacidad y la Politica de Uso Aceptable.

**2.3.** El Administrador del Tenant, al contratar el Servicio, acepta estos Terminos en nombre y representacion de su organizacion, vinculando a todos los Usuarios que accedan a la Plataforma bajo dicho Tenant.

**2.4.** En caso de no estar de acuerdo con alguna disposicion de los presentes Terminos, el Usuario debera abstenerse de utilizar la Plataforma y solicitar la cancelacion de su cuenta.

---

## 3. DESCRIPCION DEL SERVICIO

**3.1.** PricingIntelligence es una plataforma de inteligencia de precios y gestion comercial que ofrece, entre otras, las siguientes funcionalidades:

   a) **Modelos de Precios:** Creacion y gestion de modelos de calculo basados en formulas y variables configurables por el Usuario;

   b) **Cotizaciones:** Generacion, administracion y seguimiento de cotizaciones comerciales con multiples secciones y lineas de detalle;

   c) **Flujos de Aprobacion:** Gestion de procesos de aprobacion de cotizaciones con roles diferenciados;

   d) **Gestion de Materiales:** Catalogo de materiales y productos con precios y atributos configurables;

   e) **Asistente de IA:** Herramienta de apoyo basada en inteligencia artificial para consultas relacionadas con pricing y gestion comercial;

   f) **Monitoreo de Precios:** Recopilacion y analisis de precios de competidores a partir de fuentes publicas;

   g) **Reportes y Documentos:** Generacion de reportes, documentos PDF y analisis de datos comerciales;

   h) **Gestion Multi-Tenant:** Entornos aislados para cada organizacion con gestion de roles y permisos.

**3.2.** El Servicio se proporciona "tal cual" y "segun disponibilidad". El Proveedor realizara esfuerzos comercialmente razonables para mantener la disponibilidad y funcionalidad del Servicio conforme al Acuerdo de Nivel de Servicio (SLA) aplicable al Plan contratado.

**3.3.** **AVISO FUNDAMENTAL:** PricingIntelligence es una herramienta de apoyo a la gestion comercial. Los precios, calculos, sugerencias y analisis generados por la Plataforma son de caracter referencial y orientativo. La Plataforma NO sustituye el juicio comercial, profesional ni empresarial del Usuario, ni constituye asesoria de precios, tributaria, financiera o legal de ninguna naturaleza.

**3.4.** El Proveedor se reserva el derecho de modificar, ampliar, reducir o descontinuar funcionalidades del Servicio, con sujecion a lo establecido en la seccion 16 de los presentes Terminos.

---

## 4. REGISTRO Y CUENTAS DE USUARIO

**4.1.** Para acceder a las funcionalidades de la Plataforma, el Usuario debera completar el proceso de registro proporcionando informacion veraz, completa y actualizada, incluyendo, pero no limitado a: nombre completo, correo electronico corporativo, nombre de la empresa y, opcionalmente, NIT.

**4.2.** El Usuario es responsable de:

   a) Mantener la confidencialidad y seguridad de sus Credenciales de Acceso;

   b) Todas las actividades que se realicen bajo su cuenta;

   c) Notificar de forma inmediata al Proveedor cualquier uso no autorizado de su cuenta o cualquier otra violacion de seguridad;

   d) Mantener actualizada su informacion de registro.

**4.3.** El Proveedor se reserva el derecho de rechazar registros, suspender o cancelar cuentas que:

   a) Contengan informacion falsa o enganosa;

   b) Vulneren los presentes Terminos o la Politica de Uso Aceptable;

   c) Representen un riesgo para la seguridad de la Plataforma o de otros Usuarios.

**4.4.** Cada cuenta de Usuario es personal e intransferible. Esta prohibido compartir Credenciales de Acceso con terceros no autorizados.

---

## 5. PLANES Y SUSCRIPCIONES

**5.1.** El Servicio se ofrece mediante planes de suscripcion con diferentes niveles de funcionalidad, capacidad y precio. Las caracteristicas, limites y precios de cada Plan se encuentran detallados en [URL_PLANES].

**5.2.** Los precios publicados no incluyen el Impuesto al Valor Agregado (IVA) del trece por ciento (13%), salvo indicacion expresa en contrario. El Proveedor emitira la nota fiscal electronica correspondiente conforme a la normativa del Servicio de Impuestos Nacionales (SIN).

**5.3.** El pago de la suscripcion se realizara de forma anticipada, en los periodos y condiciones establecidos para cada Plan (mensual o anual).

**5.4.** El incumplimiento en el pago por un periodo superior a [DIAS_GRACIA] dias habiles facultara al Proveedor para suspender el acceso al Servicio hasta la regularizacion del pago.

**5.5.** Las suscripciones se renovaran automaticamente al vencimiento de cada periodo, salvo que el Tenant notifique su intencion de no renovar con al menos treinta (30) dias de anticipacion al vencimiento.

---

## 6. OBLIGACIONES DEL USUARIO

**6.1.** El Usuario se obliga a:

   a) Utilizar la Plataforma de conformidad con los presentes Terminos, la legislacion boliviana vigente y las buenas costumbres;

   b) Proporcionar informacion veraz, completa y actualizada en todo momento;

   c) No utilizar la Plataforma para fines ilicitos, fraudulentos o contrarios al orden publico;

   d) No intentar acceder a datos, cuentas o funcionalidades de otros Tenants;

   e) No realizar ingenieria inversa, descompilar, desensamblar o intentar obtener el codigo fuente de la Plataforma;

   f) No utilizar la Plataforma para practicas de colusion de precios, fijacion anticompetitiva de precios ni cualquier otra practica prohibida por la normativa de competencia boliviana, incluyendo el Decreto Supremo 29519;

   g) Cumplir con la normativa tributaria y comercial vigente en las cotizaciones y transacciones que realice utilizando la Plataforma;

   h) Mantener la confidencialidad de sus Credenciales de Acceso y no compartirlas con terceros;

   i) No sobrecargar, interferir ni interrumpir el funcionamiento de la Plataforma o sus infraestructuras;

   j) Respetar los derechos de propiedad intelectual del Proveedor y de terceros;

   k) Reportar de forma inmediata cualquier vulnerabilidad de seguridad que detecte en la Plataforma.

**6.2.** El incumplimiento de cualquiera de estas obligaciones podra dar lugar a la suspension o terminacion del Servicio, sin perjuicio de las acciones legales que correspondan.

---

## 7. USO ACEPTABLE

**7.1.** El uso de la Plataforma se rige por la Politica de Uso Aceptable publicada en [URL_POLITICA_USO_ACEPTABLE] y disponible en el documento complementario "Politica de Uso Aceptable de PricingIntelligence", la cual forma parte integrante de los presentes Terminos.

**7.2.** Sin perjuicio de lo establecido en la Politica de Uso Aceptable, queda expresamente prohibido:

   a) Utilizar la Plataforma para almacenar, procesar o transmitir datos regulados del sector salud, financiero o de seguridad nacional que no esten directamente relacionados con la gestion de precios;

   b) Utilizar mecanismos automatizados para acceder a la Plataforma de manera que exceda los limites de uso razonables o del Plan contratado;

   c) Utilizar la Plataforma para enviar comunicaciones no solicitadas (spam) o contenido malicioso;

   d) Sublicenciar, revender o redistribuir el acceso al Servicio sin autorizacion expresa del Proveedor.

---

## 8. ASISTENTE DE INTELIGENCIA ARTIFICIAL

**8.1. Naturaleza del Servicio.** El Asistente de IA integrado en PricingIntelligence utiliza modelos de lenguaje de gran tamano proporcionados por Anthropic, Inc. (en adelante, "Proveedor de IA"), una empresa constituida en los Estados Unidos de America.

**8.2. Caracter No Vinculante.** El Usuario reconoce y acepta expresamente que:

   a) El Contenido Generado por IA tiene caracter exclusivamente **informativo y orientativo**;

   b) El Contenido Generado por IA **NO constituye** asesoria profesional, legal, tributaria, financiera, contable ni de ninguna otra naturaleza;

   c) El Asistente de IA puede generar respuestas **inexactas, incompletas, desactualizadas o erroneas**;

   d) El Asistente de IA **NO tiene acceso a informacion de mercado en tiempo real** y sus respuestas se basan en patrones estadisticos;

   e) Las sugerencias del Asistente de IA **NO son vinculantes** y no generan obligacion alguna para el Proveedor;

   f) Es responsabilidad exclusiva del Usuario **verificar, validar y contrastar** toda informacion proporcionada por el Asistente de IA antes de tomar decisiones comerciales o de cualquier otra indole.

**8.3. Procesamiento de Datos por el Asistente de IA.** Las consultas realizadas al Asistente de IA son procesadas por el Proveedor de IA (Anthropic, Inc.) conforme a lo detallado en la Politica de Privacidad. El Usuario consiente expresamente la transferencia internacional de los datos contenidos en sus consultas para este fin.

**8.4. Limitaciones.** El Proveedor no garantiza la disponibilidad continua del Asistente de IA, la cual depende de la disponibilidad del servicio del Proveedor de IA. Interrupciones en el Asistente de IA no afectan la disponibilidad de las demas funcionalidades de la Plataforma.

---

## 9. MONITOREO DE PRECIOS DE COMPETIDORES (SCRAPING)

**9.1. Descripcion.** La Plataforma ofrece funcionalidades de monitoreo automatizado de precios publicados en fuentes de acceso publico en internet (sitios web de comercio electronico, marketplaces, catalogos en linea).

**9.2. Datos Publicos.** La informacion recopilada mediante las funcionalidades de monitoreo corresponde exclusivamente a datos que se encuentran publicamente disponibles en internet. El Proveedor no accede a informacion protegida, restringida ni de acceso privado.

**9.3. Responsabilidad del Usuario.** El Usuario es el unico responsable de:

   a) Configurar el monitoreo de precios de conformidad con la legislacion aplicable;

   b) Asegurar que el uso de la informacion recopilada cumpla con la normativa de competencia, propiedad intelectual y proteccion de datos vigente;

   c) No utilizar la informacion recopilada para practicas anticompetitivas, incluyendo la fijacion concertada de precios o la division de mercados;

   d) Cumplir con los terminos de uso de los sitios web monitoreados;

   e) No configurar frecuencias de monitoreo que puedan causar perjuicio a los sitios web objetivo.

**9.4. Deslinde.** El Proveedor no se responsabiliza por la exactitud, completitud, vigencia ni confiabilidad de los datos recopilados de fuentes externas. La informacion de monitoreo se proporciona "tal cual" y su uso es bajo exclusivo riesgo del Usuario.

**9.5.** El Proveedor se reserva el derecho de limitar, suspender o descontinuar funcionalidades de monitoreo cuando detecte usos abusivos, reclamos de terceros o cambios en la disponibilidad de las fuentes de datos.

---

## 10. PROPIEDAD INTELECTUAL

**10.1.** La Plataforma, incluyendo pero no limitado a su codigo fuente, codigo objeto, diseno, interfaz de usuario, logotipos, marcas, textos, graficos, documentacion tecnica, algoritmos, modelos de datos y arquitectura, es propiedad exclusiva de [NOMBRE DE LA EMPRESA] y se encuentra protegida por las leyes de propiedad intelectual del Estado Plurinacional de Bolivia, conforme al articulo 103 de la Constitucion Politica del Estado y la normativa administrada por el Servicio Nacional de Propiedad Intelectual (SENAPI).

**10.2.** Los presentes Terminos otorgan al Usuario una licencia de uso limitada, no exclusiva, no transferible, no sublicenciable y revocable para acceder y utilizar la Plataforma unicamente para los fines previstos y durante la vigencia de la suscripcion.

**10.3.** Esta licencia no confiere al Usuario ningun derecho de propiedad sobre la Plataforma ni sobre sus componentes. Quedan expresamente prohibidas la reproduccion, distribucion, comunicacion publica, transformacion, descompilacion, ingenieria inversa o cualquier otra forma de explotacion no autorizada de la Plataforma o sus elementos.

**10.4.** Las marcas, nombres comerciales, logotipos y signos distintivos de PricingIntelligence son propiedad de [NOMBRE DE LA EMPRESA]. Su uso no autorizado constituye infraccion marcaria conforme a la Decision 486 de la Comunidad Andina de Naciones.

---

## 11. PROPIEDAD DE LOS DATOS DEL CLIENTE

**11.1.** El Tenant y sus Usuarios retienen la titularidad plena y exclusiva de todos los Datos del Cliente ingresados, generados o almacenados en la Plataforma.

**11.2.** El Proveedor no adquiere ningun derecho de propiedad sobre los Datos del Cliente. El Tenant otorga al Proveedor una licencia limitada y no exclusiva para almacenar, procesar y mostrar los Datos del Cliente unicamente en la medida necesaria para la prestacion del Servicio.

**11.3.** El Proveedor se compromete a:

   a) No vender, comercializar, ceder ni compartir los Datos del Cliente con terceros, salvo lo estrictamente necesario para la prestacion del Servicio o por requerimiento legal formal;

   b) No utilizar los Datos del Cliente para entrenar modelos de inteligencia artificial ni para fines ajenos a la prestacion del Servicio;

   c) Mantener el aislamiento logico de los Datos del Cliente entre Tenants;

   d) Facilitar la exportacion de los Datos del Cliente en formatos estandar a solicitud del Tenant.

---

## 12. PRIVACIDAD Y PROTECCION DE DATOS

**12.1.** El tratamiento de datos personales realizado a traves de la Plataforma se rige por la Politica de Privacidad de PricingIntelligence, disponible en [URL_POLITICA_PRIVACIDAD], la cual forma parte integrante de los presentes Terminos.

**12.2.** El Proveedor se compromete a tratar los datos personales de conformidad con la Ley 164 (Ley General de Telecomunicaciones, TIC y Servicio Postal), el Decreto Supremo 1793, y los principios constitucionales de proteccion de datos consagrados en los articulos 21 y 25 de la Constitucion Politica del Estado.

**12.3.** Para los Tenants que lo requieran, el Proveedor pondra a disposicion un Acuerdo de Procesamiento de Datos (DPA) complementario.

---

## 13. LIMITACION DE RESPONSABILIDAD

**13.1.** EN LA MAXIMA MEDIDA PERMITIDA POR LA LEGISLACION BOLIVIANA VIGENTE, Y SIN PERJUICIO DE LO ESTABLECIDO EN LOS ARTICULOS 984 Y 994 DEL CODIGO CIVIL BOLIVIANO:

**13.2.** El Proveedor NO sera responsable por:

   a) Decisiones comerciales, financieras, tributarias o de cualquier otra naturaleza tomadas por el Usuario basandose en los datos, modelos, calculos, sugerencias o analisis generados por la Plataforma;

   b) Perdidas economicas, lucro cesante, dano emergente, danos indirectos, incidentales, especiales, punitivos o consecuenciales derivados del uso o imposibilidad de uso de la Plataforma;

   c) Errores en los precios calculados cuando estos resulten de datos incorrectos, incompletos, desactualizados o erroneos ingresados por el Usuario;

   d) Inexactitud, incompletitud o improcedencia de las recomendaciones del Asistente de IA;

   e) Interrupciones del Servicio por causas de fuerza mayor, mantenimiento programado, fallas en servicios de terceros o circunstancias fuera del control razonable del Proveedor;

   f) Uso indebido de la Plataforma por parte del Usuario, sus empleados, dependientes o terceros autorizados;

   g) Incumplimiento de la normativa tributaria, comercial, de competencia o de cualquier otra naturaleza por parte del Usuario en relacion con las cotizaciones, precios o transacciones realizadas utilizando la Plataforma;

   h) Perdida de datos causada por negligencia del Usuario en la gestion de sus Credenciales de Acceso;

   i) Danos derivados de la informacion obtenida mediante las funcionalidades de monitoreo de precios;

   j) Acciones u omisiones del Proveedor de IA (Anthropic, Inc.) o cualquier otro proveedor de servicios de terceros.

**13.3.** EN TODO CASO, LA RESPONSABILIDAD TOTAL ACUMULADA DEL PROVEEDOR POR CUALQUIER CONCEPTO Y BAJO CUALQUIER TEORIA DE RESPONSABILIDAD (CONTRACTUAL, EXTRACONTRACTUAL O DE CUALQUIER OTRA NATURALEZA) NO EXCEDERA, EN NINGUN CASO, EL MONTO TOTAL EFECTIVAMENTE PAGADO POR EL TENANT EN LOS DOCE (12) MESES INMEDIATAMENTE ANTERIORES AL EVENTO QUE GENERE LA RECLAMACION.

**13.4.** Las limitaciones establecidas en esta seccion no se aplicaran en caso de dolo o culpa grave del Proveedor, ni en aquellos supuestos en los que la legislacion boliviana no permita la limitacion de responsabilidad.

---

## 14. INDEMNIZACION

**14.1.** El Usuario se obliga a indemnizar, defender y mantener indemne al Proveedor, sus directores, empleados, agentes y representantes frente a cualquier reclamacion, demanda, dano, perdida, responsabilidad, costo o gasto (incluyendo honorarios razonables de abogados) que se derive de:

   a) El incumplimiento por parte del Usuario de los presentes Terminos;

   b) La violacion de derechos de terceros por parte del Usuario;

   c) El uso indebido de la Plataforma por parte del Usuario;

   d) La infraccion de la normativa boliviana vigente por parte del Usuario en relacion con el uso de la Plataforma;

   e) Reclamaciones de terceros derivadas de las cotizaciones, precios o transacciones realizadas por el Usuario utilizando la Plataforma;

   f) El uso de la informacion obtenida mediante las funcionalidades de monitoreo de precios en contravencion de la normativa aplicable.

---

## 15. DISPONIBILIDAD DEL SERVICIO Y FUERZA MAYOR

**15.1.** El Proveedor realizara esfuerzos comercialmente razonables para mantener la disponibilidad del Servicio conforme al SLA aplicable al Plan contratado.

**15.2.** El Proveedor podra interrumpir temporalmente el Servicio para realizar tareas de mantenimiento programado, las cuales seran notificadas con al menos cuarenta y ocho (48) horas de anticipacion.

**15.3.** Ninguna de las partes sera responsable por el incumplimiento de sus obligaciones cuando este sea causado por eventos de fuerza mayor o caso fortuito, conforme a lo establecido en los articulos 577 y 578 del Codigo Civil boliviano. Se consideraran eventos de fuerza mayor, a titulo enunciativo y no limitativo:

   a) Desastres naturales, epidemias, pandemias;

   b) Conflictos armados, actos de terrorismo, bloqueos, convulsiones sociales;

   c) Actos de autoridad gubernamental, cambios legislativos o regulatorios;

   d) Fallas en la infraestructura de telecomunicaciones o suministro electrico;

   e) Ciberataques de gran escala que afecten la infraestructura tecnologica;

   f) Interrupciones en servicios de proveedores esenciales fuera del control del Proveedor.

**15.4.** La parte afectada por un evento de fuerza mayor debera notificar a la otra parte dentro de las setenta y dos (72) horas siguientes al inicio del evento, detallando la naturaleza del mismo y su impacto estimado.

---

## 16. MODIFICACIONES A LOS TERMINOS

**16.1.** El Proveedor se reserva el derecho de modificar los presentes Terminos en cualquier momento, con sujecion al siguiente procedimiento:

   a) Las modificaciones seran notificadas al Usuario con al menos treinta (30) dias de anticipacion a su entrada en vigencia, mediante correo electronico a la direccion registrada y aviso visible en la Plataforma;

   b) Las modificaciones sustanciales (que afecten derechos fundamentales del Usuario, precios o limitaciones de responsabilidad) requeriran aceptacion expresa del Usuario;

   c) El uso continuado de la Plataforma tras la entrada en vigencia de las modificaciones se considerara aceptacion tacita de las mismas;

   d) Si el Usuario no acepta las modificaciones, podra solicitar la terminacion de su suscripcion sin penalidad antes de la fecha de entrada en vigencia de las modificaciones.

**16.2.** Las versiones anteriores de los Terminos se mantendran disponibles para consulta en [URL_VERSIONES_TERMINOS].

---

## 17. SUSPENSION DEL SERVICIO

**17.1.** El Proveedor podra suspender temporal o definitivamente el acceso del Usuario o del Tenant al Servicio en los siguientes supuestos:

   a) Incumplimiento de los presentes Terminos o de la Politica de Uso Aceptable;

   b) Falta de pago de la suscripcion por un periodo superior a [DIAS_GRACIA] dias habiles;

   c) Actividades que representen un riesgo para la seguridad, integridad o disponibilidad de la Plataforma o de los datos de otros Tenants;

   d) Requerimiento de autoridad competente;

   e) Uso de la Plataforma para fines ilicitos o contrarios al orden publico;

   f) Indicios razonables de acceso no autorizado a la cuenta del Usuario.

**17.2.** En los supuestos de los incisos a), c), e) y f), la suspension podra ser inmediata y sin previo aviso. En los demas supuestos, el Proveedor notificara al Usuario con una anticipacion razonable.

**17.3.** Durante la suspension, los Datos del Cliente se mantendran almacenados y disponibles para exportacion, salvo disposicion en contrario de autoridad competente.

---

## 18. TERMINACION

**18.1. Terminacion por el Tenant.** El Tenant podra terminar su suscripcion en cualquier momento, notificando al Proveedor con al menos treinta (30) dias de anticipacion al vencimiento del periodo de facturacion en curso. La terminacion surtira efecto al finalizar el periodo de facturacion ya pagado.

**18.2. Terminacion por el Proveedor.** El Proveedor podra terminar la relacion contractual:

   a) Por incumplimiento grave de los presentes Terminos por parte del Usuario o del Tenant, previa notificacion y otorgamiento de un plazo de quince (15) dias para subsanar el incumplimiento, salvo que la naturaleza del incumplimiento no admita subsanacion;

   b) Por decision empresarial de descontinuar el Servicio, con una anticipacion minima de noventa (90) dias;

   c) Por requerimiento de autoridad competente.

**18.3.** No se reembolsaran pagos correspondientes a periodos de suscripcion ya iniciados, salvo en el caso de terminacion imputable al Proveedor.

---

## 19. EFECTOS DE LA TERMINACION

**19.1.** Una vez producida la terminacion efectiva de la suscripcion:

   a) El acceso del Tenant y sus Usuarios a la Plataforma sera desactivado;

   b) El Tenant dispondra de un periodo de treinta (30) dias calendario para solicitar la exportacion de sus Datos del Cliente en formatos estandar (CSV, JSON, PDF);

   c) Transcurrido el periodo de exportacion, el Proveedor procedera a la eliminacion definitiva de los Datos del Cliente de sus sistemas de produccion;

   d) Las copias de seguridad que contengan Datos del Cliente seran eliminadas dentro de los noventa (90) dias siguientes a la terminacion;

   e) Los registros necesarios para cumplir obligaciones legales y tributarias seran conservados conforme a la normativa vigente (hasta ocho (8) anos para documentacion fiscal conforme a la Ley 843).

**19.2.** La terminacion no afectara las obligaciones que por su naturaleza deban subsistir, incluyendo, a titulo enunciativo: limitacion de responsabilidad, indemnizacion, confidencialidad y propiedad intelectual.

---

## 20. RESOLUCION DE DISPUTAS

**20.1.** Las partes se comprometen a resolver cualquier controversia derivada de los presentes Terminos de buena fe y mediante negociacion directa.

**20.2.** En caso de no alcanzar un acuerdo en un plazo de treinta (30) dias desde la primera comunicacion formal de la controversia, las partes podran someter la disputa a:

   a) **Mediacion:** Ante un mediador designado de comun acuerdo o, en su defecto, designado por la Camara de Comercio de [CIUDAD];

   b) **Arbitraje:** Ante el Centro de Conciliacion y Arbitraje de la Camara de Comercio de [CIUDAD], bajo su reglamento vigente. El laudo arbitral sera definitivo y vinculante para ambas partes.

**20.3.** El proceso arbitral se llevara a cabo en la ciudad de [CIUDAD], Estado Plurinacional de Bolivia, en idioma espanol.

**20.4.** Sin perjuicio de lo anterior, cualquiera de las partes podra acudir a la jurisdiccion ordinaria para solicitar medidas cautelares o de proteccion urgente.

---

## 21. LEY APLICABLE Y JURISDICCION

**21.1.** Los presentes Terminos se rigen e interpretan conforme a las leyes del Estado Plurinacional de Bolivia, incluyendo, entre otras, las siguientes normas:

   - Constitucion Politica del Estado;
   - Codigo Civil (Decreto Ley 12760);
   - Codigo de Comercio (Decreto Ley 14379);
   - Ley 164 (Ley General de Telecomunicaciones, TIC y Servicio Postal);
   - Decreto Supremo 1793.

**21.2.** Para toda cuestion que no sea sometida a arbitraje conforme a la seccion 20, las partes se someten a la jurisdiccion de los Tribunales competentes de la ciudad de [CIUDAD], Estado Plurinacional de Bolivia, renunciando expresamente a cualquier otro fuero que pudiera corresponderles.

---

## 22. CESION

**22.1.** El Usuario no podra ceder, transferir ni delegar los derechos u obligaciones derivados de los presentes Terminos sin el consentimiento previo y por escrito del Proveedor.

**22.2.** El Proveedor podra ceder los presentes Terminos, en su totalidad o parcialmente, a un sucesor a titulo universal o a una sociedad vinculada, previa notificacion al Usuario con treinta (30) dias de anticipacion. Si el Usuario no acepta la cesion, podra terminar su suscripcion sin penalidad.

---

## 23. DIVISIBILIDAD

**23.1.** Si alguna disposicion de los presentes Terminos fuera declarada invalida, nula o inaplicable por autoridad competente, dicha declaracion no afectara la validez y vigencia de las restantes disposiciones, las cuales conservaran plena eficacia.

**23.2.** La disposicion invalida sera sustituida por una disposicion valida que refleje, en la medida de lo posible, la intencion original de las partes.

---

## 24. COMUNICACIONES Y NOTIFICACIONES

**24.1.** Todas las comunicaciones y notificaciones relacionadas con los presentes Terminos se realizaran por escrito y se consideraran validamente efectuadas cuando sean enviadas:

   a) Por correo electronico a las direcciones registradas por las partes;

   b) Mediante aviso en la Plataforma (para comunicaciones del Proveedor al Usuario);

   c) Por correo certificado o notificacion notarial al domicilio legal de la parte destinataria.

**24.2.** Las notificaciones del Usuario al Proveedor deberan dirigirse a: [EMAIL_CONTACTO_LEGAL].

**24.3.** Las notificaciones surtiran efecto desde su recepcion, entendiendose recibidas: las electronicas, al dia habil siguiente de su envio; las fisicas, conforme al acuse de recibo correspondiente.

---

## 25. ACUERDO COMPLETO

**25.1.** Los presentes Terminos, junto con la Politica de Privacidad, la Politica de Uso Aceptable, el Contrato de Licencia SaaS (cuando sea aplicable) y cualquier anexo o adenda suscrito por las partes, constituyen el acuerdo completo entre el Proveedor y el Usuario en relacion con el uso de la Plataforma.

**25.2.** Los presentes Terminos sustituyen y dejan sin efecto todos los acuerdos, comunicaciones y entendimientos previos, ya sean verbales o escritos, relativos al objeto de los mismos.

**25.3.** La renuncia del Proveedor a ejercer cualquier derecho derivado de los presentes Terminos en una ocasion determinada no constituira renuncia a ejercer dicho derecho en el futuro.

---

## 26. DISPOSICIONES FINALES

**26.1.** Los encabezados de las secciones de los presentes Terminos tienen fines unicamente referenciales y no afectaran la interpretacion de su contenido.

**26.2.** El idioma oficial de los presentes Terminos es el espanol. En caso de existir traducciones a otros idiomas, prevalecera la version en espanol.

**26.3.** La falta de ejercicio o el retraso en el ejercicio de cualquier derecho previsto en los presentes Terminos no implicara renuncia al mismo.

**26.4.** Los presentes Terminos no crean relacion de sociedad, asociacion, empleo ni agencia entre el Proveedor y el Usuario.

---

**[NOMBRE DE LA EMPRESA]**
**NIT: [NIT]**
**[DIRECCION], [CIUDAD]**
**Estado Plurinacional de Bolivia**

*Documento vigente desde [FECHA_VIGENCIA].*
*Version: 1.0*`;
